@let loggedIn = isLoggedIn();
@let admin = isAdmin();
@let profile = formattedProfile();
@let apps = userProfiles();
@let tenants = tenantsAsDropdownItems();

<div class="bo-header">
  <bo-main-logo />

  @if (loggedIn) {
    @if (!!selectedTenant() && admin) {
      <div class="bo-header__tenants">
        <label class="bo-header__tenants-label">{{ 'MTR_COMMON_TENANT' | translate }} </label>

        @if (tenants) {
          <mcui-select
            [filter]="tenants.length > 7"
            [(value)]="selectedTenant"
            [options]="tenants"
          />
        }
      </div>
    }

    <div class="bo-header__not-search-content"></div>
    @if (profile) {
      <bo-dialog-application class="app-dialog-application" #appDialog />
      <mcui-application-menu
        [config]="appConfig"
        label="APPS"
        mainSuitTitle="{{ 'MTR_APP_SUITE' | translate }}"
        thirdPartySuitTitle="{{ 'MTR_THIRD_PARTY_APPS' | translate }}"
        [applicationUserProfileTypes]="apps || []"
        (deactivatedChange)="appDialog.openModal(applicationDialogType.Contact, $event, profile)"
        (deepLinkChange)="appDialog.openModal(applicationDialogType.Download, $event, profile)"
      />
    }

    <bo-quick-view [userProfile]="profile" />
  } @else {
    <button class="bo-header__logout-bt" routerLink="login">
      {{ 'MTR_COMMON_LOGIN' | translate }}
    </button>
  }
</div>
